import {
	ActiveListingsEnum,
	SoldListingsEnum,
} from "../../services/exploreListings";

interface FilterPanelData {
	label: string;
	value: string;
	displayValue: string;
}

export const propertyActiveFilter: FilterPanelData[] = [
	{ label: "All", value: "All", displayValue: "" },
	{
		label: "Within a day",
		value: ActiveListingsEnum.Within001Day,
		displayValue: "1D",
	},
	{
		label: "Within last 3 days",
		value: ActiveListingsEnum.Within003Days,
		displayValue: "3D",
	},
	{
		label: "Within last 7 days",
		value: ActiveListingsEnum.Within007Days,
		displayValue: "7D",
	},
	{
		label: "Within last 30 days",
		value: ActiveListingsEnum.Within030Days,
		displayValue: "30D",
	},
	{
		label: "Within last 90 days",
		value: ActiveListingsEnum.Within090Days,
		displayValue: "90D",
	},
	{
		label: "More than 15 days on market",
		value: ActiveListingsEnum.MoreThan15Dom,
		displayValue: "15D+",
	},
	{
		label: "More than 30 days on market",
		value: ActiveListingsEnum.MoreThan30Dom,
		displayValue: "30D+",
	},
	{
		label: "More than 60 days on market",
		value: ActiveListingsEnum.MoreThan60Dom,
		displayValue: "60D+",
	},
	{
		label: "More than 90 days on market",
		value: ActiveListingsEnum.MoreThan90Dom,
		displayValue: "90D+",
	},
];

export const propertyDeListedAndSoldFilter: FilterPanelData[] = [
	{
		label: "Within a day",
		value: SoldListingsEnum.Within001Day,
		displayValue: "1D",
	},
	{
		label: "Within last 3 days",
		value: SoldListingsEnum.Within003Days,
		displayValue: "3D",
	},
	{
		label: "Within last 7 days",
		value: SoldListingsEnum.Within007Days,
		displayValue: "7D",
	},
	{
		label: "Within last 30 days",
		value: SoldListingsEnum.Within030Days,
		displayValue: "30D",
	},
	{
		label: "Within last 90 days",
		value: SoldListingsEnum.Within090Days,
		displayValue: "90D",
	},
	{
		label: "Within last 180 days",
		value: SoldListingsEnum.Within180Days,
		displayValue: "180D",
	},
	{
		label: "Within last 360 days",
		value: SoldListingsEnum.Within360Days,
		displayValue: "360D",
	},
	{
		label: "Year 2024",
		value: SoldListingsEnum.Year2024,
		displayValue: "2024",
	},
	{
		label: "Year 2023",
		value: SoldListingsEnum.Year2023,
		displayValue: "2023",
	},
	{
		label: "Year 2022",
		value: SoldListingsEnum.Year2022,
		displayValue: "2022",
	},
	{
		label: "Year 2021",
		value: SoldListingsEnum.Year2021,
		displayValue: "2021",
	},
	{
		label: "Year 2020",
		value: SoldListingsEnum.Year2020,
		displayValue: "2020",
	},
];
